import { render, staticRenderFns } from "./TestimonialHomeRtl.vue?vue&type=template&id=762ae36d"
import script from "./TestimonialHomeRtl.vue?vue&type=script&lang=js"
export * from "./TestimonialHomeRtl.vue?vue&type=script&lang=js"
import style0 from "./TestimonialHomeRtl.vue?vue&type=style&index=0&id=762ae36d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports